import { useTranslation } from 'react-i18next';

import { useError } from '../../../providers/useError';

export const usePlaceBidErrors = () => {
  const { t } = useTranslation('onsite');
  const { errorMessage } = useError();

  const amountTooLow = () => errorMessage(t('bids.amount-too-low'));

  const auctionExpired = () => errorMessage(t('bids.auction-expired'));

  const amountOverLimit = () => errorMessage(t('bids.amount-over-limit'));

  const unknownError = () => errorMessage();

  return { amountTooLow, auctionExpired, amountOverLimit, unknownError };
};
